
import { Options, prop, Vue } from "vue-class-component";
import { OptionsClass } from "@/domain/entities/MainApp";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { LOCATION_AREA } from "../misc";
import Checkbox from "primevue/checkbox";
import { SearchSttFilter } from "@/data/payload/api/CariSttApiRequest";

class Props {
  disabled = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  emits: ["filter", "submit"],
  components: {
    Checkbox
  }
})
class ScanFilterComponent extends Vue.with(Props) {
  form = new SearchSttFilter();

  onSearch(value: string) {
    if (!value || value.length >= 3) {
      this.form.search = value;
      this.onFilter();
    }
  }

  openLastStatus = false;
  get showRccImp() {
    const isAccountCountryMY =
      AccountController.accountData.account_type_detail.countryCode?.toLowerCase() ===
      "my";

    const isInternalAccount = AccountController.accountData.isInternalAccount;

    return isAccountCountryMY || isInternalAccount;
  }
  lastStatusList = [
    {
      name: "BKD",
      value: "BKD"
    },
    {
      name: "PUP",
      value: "PUP"
    },
    {
      name: "STI-SC",
      value: "STI-SC"
    },
    {
      name: "STI",
      value: "STI"
    },
    {
      name: "BAGGING",
      value: "BAGGING"
    },
    {
      name: "CARGO PLANE",
      value: "CARGO PLANE"
    },
    {
      name: "CARGO TRUCK",
      value: "CARGO TRUCK"
    },
    {
      name: "CARGO TRAIN",
      value: "CARGO TRAIN"
    },
    {
      name: "CARGO SHIP",
      value: "CARGO SHIP"
    },
    {
      name: "PICKUP TRUCK",
      value: "PICKUP TRUCK"
    },
    {
      name: "DROPOFF TRUCK",
      value: "DROPOFF TRUCK"
    },
    {
      name: "TRANSIT",
      value: "TRANSIT"
    },
    {
      name: "STI-DEST",
      value: "STI-DEST"
    },
    {
      name: "HND",
      value: "HND"
    },
    {
      name: "DEL",
      value: "DEL"
    },
    {
      name: "STT REMOVE",
      value: "STT REMOVE"
    },
    {
      name: "STT ADJUSTED",
      value: "STT ADJUSTED"
    },
    {
      name: "HAL",
      value: "HAL"
    },
    {
      name: "ODA",
      value: "ODA"
    },
    {
      name: "OCC",
      value: "OCC"
    },
    {
      name: "STO-SC",
      value: "STO-SC"
    },
    {
      name: "OCC-HAL",
      value: "OCC-HAL"
    },
    {
      name: "OCC-EXP",
      value: "OCC-EXP"
    },
    {
      name: "OCC-IMP",
      value: "OCC-IMP"
    },
    {
      name: "INTHND",
      value: "INTHND"
    },
    {
      name: "INT-STI",
      value: "INT-STI"
    },
    {
      name: "IN-HUB",
      value: "IN-HUB"
    },
    {
      name: "OUT-HUB",
      value: "OUT-HUB"
    },
    {
      name: "KONDISPATCH",
      value: "KONDISPATCH"
    },
    {
      name: "STLDISPATCH",
      value: "STLDISPATCH"
    },
    ...(this.showRccImp
      ? [
          {
            name: "RCC-IMP",
            value: "RCC-IMP"
          }
        ]
      : []),
    {
      name: "DEX",
      value: "DEX"
    },
    {
      name: "SCRAP",
      value: "SCRAP"
    },
    {
      name: "SHORTLAND",
      value: "SHORTLAND"
    },
    {
      name: "MIS-ROUTE",
      value: "MIS-ROUTE"
    },
    {
      name: "CODREJ",
      value: "CODREJ"
    },
    {
      name: "MISSING",
      value: "MISSING"
    },
    {
      name: "DAMAGE",
      value: "DAMAGE"
    },
    {
      name: "NOT RECEIVED",
      value: "NOT RECEIVED"
    },
    {
      name: "MISBOOKING",
      value: "MISBOOKING"
    },
    {
      name: "REJECTED",
      value: "REJECTED"
    },
    {
      name: "POD",
      value: "POD"
    },
    {
      name: "CNX",
      value: "CNX"
    },
    {
      name: "RTS",
      value: "RTS"
    },
    {
      name: "CLAIM",
      value: "CLAIM"
    },
    {
      name: "CI",
      value: "CI"
    },
    {
      name: "RTSHQ",
      value: "RTSHQ"
    },
    {
      name: "STT ADJUSTED POD",
      value: "STT ADJUSTED POD"
    },
    {
      name: "REROUTE",
      value: "REROUTE"
    },
    {
      name: "CNXCD",
      value: "CNXCD"
    },
    {
      name: "HALCD",
      value: "HALCD"
    },
    {
      name: "SCRAPCD",
      value: "SCRAPCD"
    }
  ]

  get accountIsNonForeign() {
    return !AccountController.accountData.accountIsForeign;
  }

  onFilter() {
    this.$emit(
      "filter",
      this.form,
    );
  }

  locationArea = LOCATION_AREA.map(
    (item) => new OptionsClass({ ...item, name: item.name.toUpperCase() })
  );
  onSelectLocation(item: OptionsClass) {
    if (this.form.scanLocation === item.value) {
      this.form.scanLocation = "";
    } else {
      this.form.scanLocation = item.value;
    }
    this.onFilter();
  }

  onSelectStatus(item: OptionsClass) {
    if (this.form.lastStatus === item.value) {
      this.form.lastStatus = "";
    } else {
      this.form.lastStatus = item.value;
    }
    this.onFilter();
  }

  get isPosAccount() {
    return AccountController.accountData.isPosAccount;
  }
}
export default ScanFilterComponent;
